import * as React from 'react'
import { Container } from 'components/Layout'
import cn from 'classnames'
import * as sText from 'components/Text/Text.scss'
import { ContactCreate } from 'features/Contacts/ContactCreate'
import * as sMarg from 'styles/modules/margins.scss'
import { IContactCreateModalActionProps } from './ContactCreateModal.action'

export interface IContactCreateModalProps extends IContactCreateModalActionProps {
  modalCancel: () => undefined
}

export class ContactCreateModal extends React.Component<IContactCreateModalProps> {
  render() {
    const { modalCancel, phoneNumber } = this.props
    return (
      <Container paddingTop paddingBottom className="sm">
        <div style={{ margin: '0 30px' }}>
          <div className={cn(sText.descrip2, sText.center, sMarg.mb30)}>Create a new contact:</div>
          <ContactCreate
            onAfterSubmit={modalCancel}
            initialValues={{
              phoneNumbers: [phoneNumber],
            }}
          />
        </div>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// src/features/Contacts/ContactCreateModal/ContactCreateModal.tsx